type FontConfig = {
    fontFamily: string;
    fontWeight: "normal" | "bold";
    fontSize: number;
    letterSpacing?: number;
    lineHeight?: number;
};


type TextType = "heading" | "description" | "volatility" | "continue" | "introHeading" | "introDesc1" | "introDesc2" | "introContinue";

const fontConfigs: Record<string, Record<TextType, FontConfig>> = {
    default: {
        heading: {
            fontFamily: "Helvetica",
            fontWeight: "bold",
            fontSize: 32,
            letterSpacing: 1,
            // lineHeight: 50,
        },
        description: {
            fontFamily: "Helvetica",
            fontWeight: "normal",
            fontSize: 32,
            letterSpacing: 1,
            // lineHeight: 35,
        },
        volatility: {
            fontFamily: "Helvetica",
            fontWeight: "bold",
            fontSize: 22,
        },
        continue: {
            fontFamily: "Helvetica",
            fontWeight: "normal",
            fontSize: 35,
        },
        introHeading: {
            fontFamily: "Helvetica",
            fontWeight: "bold",
            fontSize: 72,
        },
        introDesc1: {
            fontFamily: "Helvetica",
            fontWeight: "bold",
            fontSize: 65,
            // lineHeight: 58
        },
        introDesc2: {
            fontFamily: "Helvetica",
            fontWeight: "normal",
            fontSize: 45,
            // lineHeight: 38
        },
        introContinue: {
            fontFamily: "Helvetica",
            fontWeight: "normal",
            fontSize: 50,
        },
    },
    en: {
        heading: {
            fontFamily: "Adonais",
            fontWeight: "normal",
            fontSize: 40,
            letterSpacing: 1,
            // lineHeight: 50,
        },
        description: {
            fontFamily: "Adonais",
            fontWeight: "normal",
            fontSize: 25,
            letterSpacing: 3,
            // lineHeight: 30,
        },
        volatility: {
            fontFamily: "Adonais",
            fontWeight: "normal",
            fontSize: 36,
        },
        continue: {
            fontFamily: "Adonais",
            fontWeight: "normal",
            fontSize: 84,
        },
        introHeading: {
            fontFamily: "Adonais",
            fontWeight: "bold",
            fontSize: 90,
        },
        introDesc1: {
            fontFamily: "Adonais",
            fontWeight: "normal",
            fontSize: 50,
            // lineHeight: 50
        },
        introDesc2: {
            fontFamily: "Adonais",
            fontWeight: "normal",
            fontSize: 50,
            // lineHeight: 45

        },
        introContinue: {
            fontFamily: "Adonais",
            fontWeight: "normal",
            fontSize: 55,
        },

    },

};

export function getFontConfig(language: string, textType: TextType): FontConfig {

    // const asianLanguages = new Set(['zh-cn', 'ko-kr', 'th-th', 'ja-jp', 'vi-vn', 'hu-hu', 'ro-ro', 'sv-se', 'lt-lt', "pl-pl", "da-dk", "pt-pt", "pt-br"]);
    let effectiveLanguage: string;

    if (language === "en-us") {
        effectiveLanguage = "en";
    } else {
        effectiveLanguage = "default";
    }

    const languageConfig = fontConfigs[effectiveLanguage];
    const textConfig = languageConfig[textType];


    // special checks
    if (["hu-hu"].indexOf(language) !== -1 && textType === 'description') {
        textConfig.fontSize = 25;
        textConfig.lineHeight = 35;
    }
    else if (["ja-jp"].indexOf(language) !== -1 && textType === 'description') {
        textConfig.fontSize = 24;
        textConfig.lineHeight = 35;
    }
    else if (["lt-lt"].indexOf(language) !== -1 && textType === 'description') {
        textConfig.fontSize = 25;
        textConfig.lineHeight = 27;
    }
    else if (["fr-fr"].indexOf(language) !== -1 && textType === 'introDesc2') {
        textConfig.fontSize = 38;
    }

    return textConfig;
}
